import Dialog from '@mui/material/Dialog';
import React, { useMemo } from 'react';
import { DeleteGoalError } from 'shared/dialogs/delete-goal/delete-goal-error';
import { DeleteGoalLoading } from 'shared/dialogs/delete-goal/delete-goal-loading';

import { DeleteGoalsMessage } from './delete-goals-message';

export type DeleteGoalsDialogProps = {
  open: boolean;
  count: number;
  isProject?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onRetry: () => void;
  isLoading?: boolean;
  isError?: boolean;
};

export const DeleteGoalsDialog: React.FC<DeleteGoalsDialogProps> = ({
  open,
  count,
  isProject,
  onClose,
  onRetry,
  onSubmit,
  isLoading,
  isError,
}) => {
  const content = useMemo(() => {
    if (isError) {
      // Reuse existing error component as it's generic enough or pass generic name
      return (
        <DeleteGoalError
          name={`${count} goals`}
          onRetry={onRetry}
          onCancel={onClose}
        />
      );
    }

    if (isLoading) {
      return <DeleteGoalLoading />;
    }

    return (
      <DeleteGoalsMessage
        count={count}
        isProject={isProject}
        onSubmit={onSubmit}
        onCancel={onClose}
      />
    );
  }, [isError, isLoading, isProject, count, onClose, onRetry, onSubmit]);

  return (
    <Dialog open={open} fullWidth onClose={!isLoading ? onClose : undefined}>
      {content}
    </Dialog>
  );
};
